module.exports = __webpack_public_path__ + "static/media/04(3).13925d24.jpg";